// src/utils/refundPrintDispatch.js
//
// The refund slip's sibling of utils/ticketPrintDispatch.js, and it exists
// for exactly the same reason.
//
// A refund print is a network round trip to a backend known to cold-start,
// followed by a LAN POST to a printer that may be off. It sits on a path a
// human is waiting on — the cashier is holding the modal open with the
// customer in front of them — and nothing downstream reads its result. So
// it is STARTED here and never awaited:
//
//   * the caller returns immediately, whatever the printer does;
//   * a rejection can never surface as an unhandled rejection, and above
//     all can never surface as a FAILED REFUND.
//
// That last point is the whole contract. The money has already left the
// drawer and the Refund row already exists on the server by the time this
// is called — a print failure rolling that back, or even displaying as an
// error, would be strictly worse than no slip. `printRefundSlip` is
// contractually non-throwing already; the try/catch is belt-and-braces for
// a synchronous throw it could never normally produce.
//
// Ordering matters and is the caller's job: `refundId` only exists once
// POST /refunds has resolved. This is the trap that kept staff-meal tickets
// off paper — the print fired before the record it prints was created, so
// the id it needed did not yet exist.
import { printRefundSlip } from './PrintingUtils';

export const startRefundPrint = (refundId, tenantConfig) => {
    try {
        const pending = printRefundSlip(refundId, tenantConfig);
        if (pending && typeof pending.catch === 'function') {
            pending.catch((refundPrintError) => {
                console.error('Refund slip print failed:', refundPrintError);
            });
        }
    } catch (refundPrintError) {
        console.error('Refund slip print failed:', refundPrintError);
    }
};

export default startRefundPrint;
